import { styled } from '@volkswagen-onehub/components-core';
import React from 'react';

interface StyledPlaceholderProps {
  isInverted: boolean;
}

const Svg = styled.svg<StyledPlaceholderProps>`
  width: 100%;

  fill: ${(props: StyledPlaceholderProps) => (props.isInverted ? '#DEE1E3' : '#000000')};
`;

export function CarlinePlaceholder(props: StyledPlaceholderProps) {
  return (
    <Svg viewBox="0 10 40 20" focusable="false" isInverted={props.isInverted}>
      <path d="M33.5 20.3v-1.5s-.3-1-.9-1.8c-.6-.9-1.1-1.5-1.1-1.5V15s-4.4-.8-11-.3c-2.7.2-7.1 3.1-7.1 3.1s-3.8.4-5.8 1.3c-.6.3-1.3 1.2-1.5 1.7L6 21v.9l.3.3v1.3l3.1.5h.3c.3.9 1 1.5 2 1.5.9 0 1.7-.6 2-1.5l13.1-.3c.1 1 1 1.8 2 1.8s2-.9 2-1.9H33s.8-.4.8-.9c.2-.9.2-2 .2-2l-.5-.4z" />
    </Svg>
  );
}
